import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import Dashboard from '../components/Pages/Dashboard'
import Patient from '../components/Patients/Pages/Patient'
import Patients from '../components/Patients/Pages/Patients'
import CreateCase from '../components/Cases/Pages/CreateCase'
import CreatePgtCase from '../components/PgtCases/Pages/CreateCase'
import UpdatePgtCase from '../components/PgtCases/Pages/UpdateCase'
import Clients from '../components/Clients/Pages/Clients'
import CreateClient from '../components/Clients/Pages/CreateClient'
import Client from '../components/Clients/Pages/Client'
import OverviewClient from '../components/Clients/Pages/OverviewClient'
import ClientSpecialists from '../components/Clients/Pages/ClientSpecialists'
import ClientServices from '../components/Clients/Pages/ClientServices'
import UpdateClient from '../components/Clients/Pages/UpdateClient'
import CreateClientSpecialist from '../components/Clients/Pages/CreateClientSpecialist'
import UpdateClientSpecialist from '../components/Clients/Pages/UpdateClientSpecialist'
import CreatePatient from '@/components/Patients/Pages/CreatePatient'
import UpdatePatient from '@/components/Patients/Pages/UpdatePatient'
import OverviewPatient from '@/components/Patients/Pages/OverviewPatient'
import PatientCases from '@/components/Patients/Pages/PatientCases'
import PgtCases from '../components/PgtCases/Pages/Cases'
import Services from '../components/Services/Pages/Services'
import CreateService from '../components/Services/Pages/CreateService'
import OverviewService from '../components/Services/Pages/OverviewService'
import Service from '../components/Services/Pages/Service'
import UpdateService from '../components/Services/Pages/UpdateService'

import _ from 'lodash'
import store from '../store'

Vue.use(Router)

const r = new Router({
    //mode: 'history',
    routes: [
        {
            path: '/',
            component: Dashboard,
            async beforeEnter(to, from, next) {
                await store.dispatch('batches/getMissingSamples')
                next()
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/cases/pgt/create',
            name: 'createPgtCase',
            component: CreatePgtCase,
        },
        {
            path: '/cases/create',
            name: 'createCase',
            component: CreateCase,
        },
        {
            path: '/cases/pgt/update/:caseSystemId',
            name: 'updatePgtCase',
            component: UpdatePgtCase,
            props: true
        },
        {
            path: '/cases/pgt',
            name: 'pgtCases',
            component: PgtCases
        },
        {
            path: '/patients',
            name: 'patients',
            component: Patients,
            beforeEnter: async (to, from, next) => {
                await store.dispatch('patients/getPatients')

                next()
            },
        },
        {
            path: '/patients/create',
            name: 'createPatient',
            component: CreatePatient,
            beforeEnter: async (to, from, next) => {
                await store.dispatch('patients/initCreationPatient')
                next()
            }
        },
        {
            path: '/patients/:patientId',
            component: Patient,
            props: true,
            beforeEnter: async (to, from, next) => {
                if (!to.params.patientId) {
                    next('/')
                    return
                }

                let patient = await store.dispatch('patients/getPatientOrFetch', to.params.patientId)

                if (!patient) {
                    return next({name: 'patients'})
                }

                next()
            },
            children: [
                {
                    path: '',
                    name: 'overviewPatient',
                    component: OverviewPatient,
                    props: true
                },
                {
                    path: 'edit',
                    name: 'updatePatient',
                    component: UpdatePatient,
                    props: true,
                    beforeEnter: async (to, from, next) => {
                        await store.dispatch('patients/initEditedPatient', to.params.patientId)

                        next()
                    },
                },
                {
                    path: 'cases',
                    name: 'patientCases',
                    component: PatientCases,
                    props: true
                }
            ]
        },
        {
            path: '/clients',
            name: 'clients',
            component: Clients
        },
        {
            path: '/clients/create',
            name: 'createClient',
            component: CreateClient
        },
        {
            path: '/clients/:clientId',
            // name: 'client',
            component: Client,
            props: true,
            children: [
                {
                    path: '',
                    name: 'overviewClient',
                    component: OverviewClient,
                    props: true
                },
                {
                    path: 'edit',
                    name: 'updateClient',
                    component: UpdateClient,
                    props: true
                },
                {
                    path: 'specialists',
                    name: 'clientSpecialists',
                    component: ClientSpecialists,
                    props: true
                },
                {
                    path: 'services',
                    name: 'clientServices',
                    component: ClientServices,
                    props: true
                },
                {
                    path: 'specialists/add',
                    name: 'createSpecialist',
                    component: CreateClientSpecialist,
                    props: true
                },
                {
                    path: 'specialists/:specialistId/edit',
                    name: 'updateSpecialist',
                    component: UpdateClientSpecialist,
                    props: true
                }
            ]
        },
        {
            path: '/services',
            name: 'services',
            component: Services
        },
        {
            path: '/services/create',
            name: 'createService',
            component: CreateService
        },
        {
            path: '/services/:serviceId',
            // name: 'client',
            component: Service,
            props: true,
            children: [
                {
                    path: '',
                    name: 'overviewService',
                    component: OverviewService,
                    props: true
                },
                {
                    path: 'edit',
                    name: 'updateService',
                    component: UpdateService,
                    props: true
                },
            ]
        }
    ]
})

r.beforeEach(async (to, from, next) => {
    const isLoggedIn = _.get(store, ['getters', 'auth/isLoggedIn'], false)

    if (!isLoggedIn && to.name !== 'login') {
        next({path: '/login'})
        return
    }

    next()
})


export default r